import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const BarChartIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" />
  </BaseIcon>
)
